<template>
    <div class="white-list targeting-block">
        <div class="title">
            <span>Комментарий</span>
        </div>
        <div class="input-data">
            <textarea
                v-model="localComment"
                @input="$emit('update:comment', localComment)"
                :placeholder="placeholder"
                rows="3"
            ></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Comment',
    props: {
        placeholder: {
            type: String,
            default: 'Комментарий к кампании (необязательно)',
        },
        comment: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            localComment: this.comment || '',
        };
    },

    watch: {
        comment(newVal) {
            this.localComment = newVal || '';
        },
    },
};
</script>
